/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
import Feature from '@linc-technologies/linced-common/enums/feature';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

export default class TransactionUploadRoute extends Route {
  // Services
  @service
  store;

  model() {
    return this.store
      .query('school', { jurisdiction: Jurisdiction.AU_NSW })
      .then((schools) => {
        return schools
          .filter((school) => {
            // Filter schools to those which have an external ID (i.e. are synced
            // against DoE) and have Finance enabled.
            return (
              !isEmpty(school.externalId) &&
              school.featuresEnabled.includes(Feature.PUPIL_BILLING)
            );
          })
          .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
      });
  }

  resetController(controller) {
    controller.reset();
  }
}
